import React, { useState, useEffect } from "react";

function Intro() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      // Run your function here
      setShow(true);
    }, 3000);
    return () => {
      clearTimeout(timer); // Clear the timer if the component unmounts before 3 seconds
    };
  }, []);

  return (
    <div
      className="intro text-white d-flex align-items-center"
      id="intro"
      onClick={() => setShow(true)}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      <div className="container h-100">
        <div className="d-flex align-items-center">
          <div
            className="intro-container all"
            onMouseEnter={() => setShow(true)}
          >
            <h2 className="height-lg animated-upper-text">I can</h2>
            <div className={"hidden-text" + (show ? " show" : "")}>
              <h5>create innovative solutions,</h5>
              <h5>design user-friendly interfaces,</h5>
              <h5>and bring ideas to life</h5>
            </div>
            <h2 className="height-lg animated-bottom-text">Develop</h2>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Intro;
